<script setup lang="ts">
defineProps<{ tone: 'late' | 'new' | 'preparing' | 'done' | 'closed' }>();
</script>

<template>
  <span
    class="inline-flex h-7 shrink-0 items-center rounded-[8px] px-[10px] text-[12px] leading-[1.45] font-semibold whitespace-nowrap"
    :class="{
      'bg-alerte text-alerte-encre': tone === 'late',
      'bg-info-doux text-info-texte': tone === 'new',
      'bg-avert-doux text-avert-texte': tone === 'preparing',
      'bg-succes-doux text-succes-texte': tone === 'done',
      'bg-creux text-encre-douce': tone === 'closed',
    }"
  >
    <slot />
  </span>
</template>
